import { useCallback, useMemo } from '@redneckz/uni-jsx/lib/hooks';
import { getVersion } from '../../utils/getVersion.js';
import { getBadgeCount } from './getBadgeCount.js';
import { hotFilterRecordCmp } from './hotFilterRecordCmp.js';
const EMPTY_ARR = [];
const EMPTY_OBJ = {};
export const useHotFilters = ({ hotFilters = EMPTY_ARR, filtrationState = EMPTY_OBJ, blocks = EMPTY_ARR, onFiltrationStateChange, }) => {
    const activeItemIndex = useMemo(() => Math.max(0, hotFilters.findIndex((_) => hotFilterRecordCmp(_.filter, filtrationState))), [hotFilters, filtrationState]);
    const items = useMemo(() => hotFilters.map((_) => ({
        text: _.text,
        count: getBadgeCount(blocks, _.filter),
        version: getVersion(_ === hotFilters[activeItemIndex]),
    })), [hotFilters, blocks, activeItemIndex]);
    const handleChange = useCallback((_) => {
        onFiltrationStateChange(hotFilters[items.indexOf(_)].filter);
    }, [hotFilters, items]);
    return {
        activeItem: items[activeItemIndex],
        items: items,
        onChange: handleChange,
    };
};
//# sourceMappingURL=useHotFilters.js.map